module.exports = __webpack_public_path__ + "static/media/logoUFT.9537f94a.png";